import { MOBILE } from '@/src/constants'
import { DESKTOP } from '@/src/constants'
import { TypographyVariantType } from '@ct-design/lib/Typography/type'
import { DeviceType } from '@/src/types'

export const styleConfig: Record<
    DeviceType,
    {
        titleVariant: TypographyVariantType
        spacing: string
        visaCardPadding: string
    }
> = {
    [DESKTOP]: {
        titleVariant: 'HM1',
        spacing: 'mb-8',
        visaCardPadding: 'px-3 py-6'
    },
    [MOBILE]: {
        titleVariant: 'HM3',
        spacing: 'mb-4',
        visaCardPadding: 'px-3 py-6'
    }
}
